<template>
  <div>
    <el-form :label-position="labelPosition" label-width="80px" :rules="addFormRules" :model="formLabelAlign">
      <el-form-item label="步骤名称">
        <el-input v-model="formLabelAlign.name" disabled style="width: 360px;"></el-input>
      </el-form-item>
      <el-form-item label="选择群组" prop="addGroupId">
        <el-select @change="update" filterable v-model="formLabelAlign.addGroupId" placeholder="--请选择群组--">
          <el-option
            v-for="item in addGroupOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getGroupList } from '@/api/customer.js'
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      addFormRules: {
        addGroupId: [
          { required: true, message: '群组不能为空', trigger: 'change' }
        ]
      },
      addGroupOptions: [],
      labelPosition: 'right',
      formLabelAlign: this.contents,
      search: {
        type: 2
      }
    }
  },
  computed: {
  },
  methods: {
    // 传值到父组件
    update() {
      // 传值到父组件
      let choose = {}
      choose.nodeType = 'addGroupNode'
      choose.name = '加入群组'
      choose.addGroupId = this.formLabelAlign.addGroupId
      choose.id = this.formLabelAlign.id
      this.$emit('change', choose)
    },
    loadGroupList() {
      getGroupList(1, this.search, '').then((res) => {
        console.log('res', res)
        this.addGroupOptions = res.data.data.list
      })
    }
  },
  watch: {
    contents: function (val) {
      this.formLabelAlign = val
    }
  },
  created() {
    this.loadGroupList()
    console.log('contents', this.formLabelAlign)
  }
}
</script>

<style scoped>

</style>
